module.exports = __webpack_public_path__ + "img/deyu_caution_img.418df06b.png";